import { normalizeSavedCart } from '../Slices/Cart';
import { normalizeSession } from '../../utils/authSession';

const retainedKeys = ['authSlice', 'cartSlice', 'cookieConsent', 'language', '_persist'];

// Old installations stored entire API caches, including other sessions' responses.
export const migratePersistedState = (state) => {
  if (!state) return Promise.resolve(state);
  const retained = Object.fromEntries(Object.entries(state).filter(([key]) => retainedKeys.includes(key)));
  if (retained.cartSlice) retained.cartSlice = { items: normalizeSavedCart(retained.cartSlice.items) };
  if (retained.authSlice) retained.authSlice = normalizeSession(retained.authSlice);
  return Promise.resolve(retained);
};
